import styled from 'styled-components'

export const ErrorDiv = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	color: rgb(175, 50, 50);
`
export const SpanError = styled.span`
	padding-left: 3px;
`

export const Span = styled.span``
